import EventEditForm from "./event-edit-form";

export default EventEditForm;